import { Button } from "@/components/ui/button";
import { Package, X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface Props {
  count: number;
  onSelectBin: () => void;
  onClear: () => void;
}

export function SelectionActionBar({ count, onSelectBin, onClear }: Props) {
  const { t } = useTranslation("harvest");
  if (count === 0) return null;
  return (
    <div className="fixed bottom-36 md:bottom-24 left-1/2 -translate-x-1/2 z-40 animate-in fade-in slide-in-from-bottom-4">
      <div className="flex items-center gap-5 rounded-full bg-foreground text-background shadow-2xl px-5 py-3 border border-border/40 min-w-[420px]">
        <span className="text-sm font-medium pl-1 flex-1">
          {t("process.selectedParts", { count, defaultValue: "{{count}} parts selected" })}
        </span>
        <Button
          size="sm"
          variant="secondary"
          onClick={onSelectBin}
          className="gap-2 rounded-full"
        >
          <Package className="w-4 h-4" />
          {t("process.selectBin", { defaultValue: "Select bin" })}
        </Button>
        <button
          onClick={onClear}
          className="p-1.5 rounded-full hover:bg-background/10 transition-colors"
          aria-label={t("process.clearSelection", { defaultValue: "Clear selection" })}
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
